import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Packages from "@/components/Packages";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";

function App() {
    return (
        <div className="App min-h-screen bg-[#FAFAF5] text-[#1F2937]">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Packages />
                <Services />
                <WhyUs />
                <Testimonials />
                <BookingForm />
            </main>
            <Footer />
            <FloatingContact />
        </div>
    );
}

export default App;
